import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const getRemoteDefaultValues = ({ searchUrl, selectElement }) => {
  axios
    .get(searchUrl)
    .then(({ data }) => {
      data.forEach((item) => {
        selectElement.append(
          `<option value="${item.id}" selected="selected">${item.name}</option>`,
        );
      });
      selectElement.trigger('change');
    })
    // Silence all errors
    .catch(() => null);
};
